/** @jsxImportSource @emotion/react */
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button as BootstrapButton, ButtonGroup } from "reactstrap";
import { useTenantNavigate } from "../../../utils/tenantUrl";
import { useSwitchTabContext } from "./fields/useSwitchTab";

export function ActiveFilterBadges() {
    const { submitTabQuery, filter } = useSwitchTabContext();
    const meta_filter = (filter.meta_filter ?? {}) as Record<string, any>;

    return (
        <>
            {Object.keys(meta_filter).filter((i) => !meta_filter[i]?.hidden).map((i: any, index) => (
                <ActiveSearchBadge
                    key={index}
                    item={meta_filter[i]}
                    removeFilter={() => (meta_filter[i].optional ? submitTabQuery({ [i]: null }) : null)}
                />
            ))}
        </>
    );
}
interface ActiveSearchBadgeProps {
    item: {
        label: string,
        optional: boolean,
        editable?: boolean,
        field: string;
    };
    removeFilter: () => void;
}

function ActiveSearchBadge({ item, removeFilter }: ActiveSearchBadgeProps) {
    const navigate = useTenantNavigate();
    const { activeTab, tab_category } = useSwitchTabContext();

    if (!item) {
        return null;
    }

    const onClick = () => {
        if (item?.editable === false) {
            return;
        }
        // TODO: simplify by just using a ? parameter
        navigate(`/layer/tab/${tab_category}/${activeTab?.value}/edit-filter/${item.field}`);
    };

    const { label } = item;

    return <ButtonGroup className="text-nowrap">
        <BootstrapButton onClick={onClick} disabled={item?.editable === false} className="px-2 text-nowrap" color="secondary" >{label}</BootstrapButton>
        {item.optional && <BootstrapButton onClick={removeFilter} className="px-2" color="danger" ><FontAwesomeIcon icon={faTimes} /></BootstrapButton>}
    </ButtonGroup>;
}
